
import _ from "lodash";
import { projectTypes } from "constants/projectTypes";
import hedgeTypes from "constants/hedgeTypes";
import { map } from "constants/screenElements/closedDealTable";

import {
  formatDisplayValue,
  formatCurrency,
  formatInteger,
  formatRate,
  formatMonths,
  formatDate,
  formatDscr,
  formatNumberTwoDecimal,
  notImplemented,
  formatCurrencyTwoDecimal,
  formatDecimalNoDecimal,
  formatNumberOneDecimal,
  formatPrepayment,
  formatExtensionsQualification
} from "./formattersv2";

const {
  CASH_EQUITY,
  BROKER_COMPANY,
  MSA,
  CURRENT_BALANCE_FIXED,
  CURRENT_BALANCE_FLOATING_ALL,
  CURRENT_BALANCE_HEDGED,
  CURRENT_BALANCE_FLOATING_UNHEDGED,
  EXPENSE_RATIO,
  APPRAISED_VALUE,
  HEDGE_MTM,
  HEDGE_MATURITY,
  HEDGE_TYPE,
  BORROWING_ENTITY,
  LENDER,
  EXTENDED_MATURITY_DATE,
  MATURITY_DATE,
  PURCHASE_PRICE,
  CLOSING_DATE,
  PROJECT_TYPE,
  CAP_RATE,
  PROJECTED_EXIT_DATE,
  DEBT_MF_UNIT,
  DEBT_RSF,
  COVENANT_TEST_FREQUENCY,
  PREPAYMENT,
  LTV,
  DEBT_YIELD,
  DSCR,
  DSCR_ACTUAL,
  MAX_RECOURSE,
  IO_REMAINING,
  MONTHS_UNTIL_MATURITY,
  UPCOMING_PAYMENT,
  PROJECTED_RATE,
  CURRENT_RATE,
  UNFUNDED_COMMITMENT,
  CURRENT_BALANCE,
  EQUITY,
  REFI_CASH_OUT,
  ALL_IN_EFFECTIVE_RATE,
  GOOD_NEWS_MONEY_REMAINING_DOLLAR_AMOUNT,
  GOOD_NEWS_MONEY_REMAINING_PERCENT,
  EXTENSION_QUALIFICATION
} = map;

export default {
  [CASH_EQUITY]: formatCurrency,
  [APPRAISED_VALUE]: formatCurrency,
  [BROKER_COMPANY]: notImplemented, // association on deal
  [MSA]: formatDisplayValue,
  [CURRENT_BALANCE_FIXED]: formatCurrency,
  [CURRENT_BALANCE_FLOATING_ALL]: formatCurrency,
  [CURRENT_BALANCE_HEDGED]: formatCurrency,
  [CURRENT_BALANCE_FLOATING_UNHEDGED]: formatCurrency,
  [DSCR]: formatDscr,
  [DSCR_ACTUAL]: formatDscr,
  [EXPENSE_RATIO]: formatRate,
  [HEDGE_MTM]: formatCurrency,
  [HEDGE_MATURITY]: formatDate,
  [HEDGE_TYPE](data) {
    switch (data) {
      case hedgeTypes.CAP:
        return "Cap";
      case hedgeTypes.SWAP:
        return "Swap";
      case hedgeTypes.COLLAR:
        return "Collar";
      case hedgeTypes.CORRIDOR:
        return "Corridor";
      default:
        return "--";
    }
  },
  [BORROWING_ENTITY]: notImplemented,
  [LENDER]: formatDisplayValue,
  [EXTENDED_MATURITY_DATE]: formatDate,
  [MATURITY_DATE]: formatDate,
  [CLOSING_DATE]: formatDate,
  [CAP_RATE]: formatRate,
  [COVENANT_TEST_FREQUENCY]: notImplemented,
  [DEBT_RSF]: formatCurrencyTwoDecimal,
  [DEBT_MF_UNIT]: formatCurrency,
  [LTV]: formatRate,
  [PROJECT_TYPE]: notImplemented, // association on deal
  [PROJECTED_EXIT_DATE]: formatDate,
  [PREPAYMENT]: formatPrepayment,
  [PURCHASE_PRICE]: formatCurrency,
  [DEBT_YIELD]: formatRate,
  [MAX_RECOURSE]: formatCurrency,
  [IO_REMAINING]: formatInteger,
  [MONTHS_UNTIL_MATURITY]: formatMonths,
  [UPCOMING_PAYMENT]: formatCurrency,
  [PROJECTED_RATE]: formatRate,
  [CURRENT_RATE]: formatRate,
  [UNFUNDED_COMMITMENT]: formatCurrency,
  [CURRENT_BALANCE]: formatCurrency,
  [EQUITY]: formatCurrency,
  [REFI_CASH_OUT]: formatCurrency,
  [ALL_IN_EFFECTIVE_RATE]: formatRate,
  [GOOD_NEWS_MONEY_REMAINING_DOLLAR_AMOUNT]: formatCurrency,
  [GOOD_NEWS_MONEY_REMAINING_PERCENT]: formatRate,
  [EXTENSION_QUALIFICATION]: formatExtensionsQualification

};
